import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-deeplink-redirect',
  imports: [],
  templateUrl: './deeplink-redirect.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './deeplink-redirect.component.scss'
})
export class DeeplinkRedirectComponent implements OnInit{

  constructor(
    private route: ActivatedRoute, private router: Router
  ) {}

  ngOnInit(): void {
    const path = this.route.snapshot.queryParamMap.get('path');

    if (path) {
      this.router.navigate(['/' + path]);
    } else {
      this.router.navigate(['/']);
    }
  }

}
